import React from 'react';
import "../styles/Component4.css"
import icon from "../images/icon_ugc.png"
import ugc_text from "../images/ugc_text.png"
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";



const Component4 = () => {
  return (
    <div class="container-4">

        <div className='bar_left_4'>
            <img src={icon} alt="Icon" className="header-icon"  width={100} height={100}/>
            <img src={ugc_text} alt="Icon"   width={250} height={30}/>
        </div>

        <div className='bar_right_4'>
            <Link to="/privacy" style={{fontSize:"25px", color:"black", textDecoration:"none"}}>Privacy Policy</Link>
            <Link to="/terms" style={{fontSize:"25px", color:"black", textDecoration:"none"}}>Terms and Conditions</Link>
        </div>


    </div>
  
  );
};

export default Component4;  
